import {
  IconFile,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypePdf,
  IconFileTypeXls,
  IconPhoto,
} from "@tabler/icons-react";

const IMAGE_CONTENT_TYPES = new Set([
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
]);

export function isImageContentType(contentType) {
  const normalized = String(contentType || "").toLowerCase();
  return IMAGE_CONTENT_TYPES.has(normalized);
}

export function assetDisplayName(asset) {
  return asset?.original_filename || asset?.filename || asset?.name || "Attachment";
}

export function fileTypeIcon(contentType, size = 18) {
  const normalized = String(contentType || "").toLowerCase();

  if (isImageContentType(normalized)) {
    return <IconPhoto size={size} stroke={1.75} />;
  }
  if (normalized === "application/pdf") {
    return <IconFileTypePdf size={size} stroke={1.75} />;
  }
  if (
    normalized.includes("wordprocessingml") ||
    normalized === "application/msword"
  ) {
    return <IconFileTypeDocx size={size} stroke={1.75} />;
  }
  if (
    normalized.includes("spreadsheetml") ||
    normalized === "application/vnd.ms-excel" ||
    normalized.includes("excel") ||
    normalized.includes("sheet")
  ) {
    return <IconFileTypeXls size={size} stroke={1.75} />;
  }
  if (normalized.startsWith("text/")) {
    return <IconFileTypeDoc size={size} stroke={1.75} />;
  }

  return <IconFile size={size} stroke={1.75} />;
}
